import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useAuth } from '../contexts/AuthContext';

export type UserRole = 'free' | 'premium' | 'admin';

export function useUserRole() {
  const { user } = useAuth();
  const [role, setRole] = useState<UserRole>('free');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) {
      setRole('free');
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single();
      if (!cancelled) {
        setRole((data?.role as UserRole) ?? 'free');
        setLoading(false);
        if (error) console.warn('[useUserRole]', error.message);
      }
    })();
    return () => { cancelled = true; };
  }, [user?.id]);

  return {
    role,
    loading,
    isFree: role === 'free',
    isPremium: role === 'premium' || role === 'admin',
    isAdmin: role === 'admin',
  };
}
